module.exports = "/_next/static/images/noImage-1348d0f1b798e8b1785206f3f434b454.png";